import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b64e4c62&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b64e4c62')) {
      api.createRecord('b64e4c62', component.options)
    } else {
      api.reload('b64e4c62', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=b64e4c62&", function () {
      api.rerender('b64e4c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/App.vue"
export default component.exports